export default __webpack_public_path__ + "static/media/Blooded Jerkin of the Seven Suns.e236e07a.jpg";